export default "__VITE_ASSET__8a188a57__"